import styled from "styled-components"

export const SocialLogo = styled.img `
    
    width: auto;
    height: 30px;
    
`